//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = (fox, parentPopupName) => {
	//@ts-ignore
	require('./styles/_index.styl');
	//@ts-ignore
	require('./templates/gdprPopups.a.tpl')(fox);
	//@ts-ignore
	require('./templates/gdprCookieBanner.a.tpl')(fox);
	//@ts-ignore
	require('./widget/BasePopup')(fox, parentPopupName);
	
	const {
		factory: popupsFactory,
		SettingsCancelTypes,
		PopupWidgetClasses
	} = require('./widget/popups.es');

	const {
		factory: bannerFactory,
		BannerClassName
	} = require('./widget/CookieBanner.es');

	popupsFactory(fox);
	bannerFactory(fox);

	fox.registerOptions('@root', {
		widgets: {
			gdprMainPopup: {
				widget: PopupWidgetClasses.settings,
			},
			gdprDeleteAccount: {
				widget: PopupWidgetClasses.deleteAccount
			},
			gdprRulesActions: {
				widget: PopupWidgetClasses.rulesActions
			},
			gdprCookieBanner: {
				widget: BannerClassName
			},
			gdprAttentionActions: {
				widget: PopupWidgetClasses.attentionActions
			}
		}
	}, true, {});
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR-popups/index.es.js